import { Slider } from '@mui/material';
import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { CountryConfig } from '../../../constants/pin-limit-countries.const';
import {
  formatCurrency,
  getCurrencySymbol
} from '../../../utils/fiat-currency.util';

interface SetLimitDialogProps {
  country: CountryConfig;
  currentLimit: number | null;
  onConfirm: (limit: number) => void;
}

const SetLimitDialog: React.FC<SetLimitDialogProps> = ({
  country,
  currentLimit,
  onConfirm
}) => {
  const [val, setVal] = useState<number>(currentLimit ?? 0);
  const { currencyCode, min, max, step } = country;
  const symbol = getCurrencySymbol(currencyCode);

  const handleChange = (_: Event, newValue: number | number[]) => {
    setVal(newValue as number);
  };

  const noteMessage =
    val > 0
      ? `For purchases above ${formatCurrency(val, currencyCode)} PIN will be required`
      : `Setting ${formatCurrency(0, currencyCode)} means PIN will be required for every transaction`;

  return (
    <div className="w-[320px] shrink-0 p-2">
      <h2 className="mb-4 text-center text-base font-semibold text-gray-700">
        Single Transaction Limit
      </h2>
      <div className="mb-4 flex h-12 items-center justify-center gap-x-1">
        <span className="text-3xl font-bold text-gray-900">{symbol}</span>
        <span className="text-3xl font-bold text-orange-500">
          {val.toFixed(2)}
        </span>
      </div>
      <Slider
        className="min-w-[200px]"
        size="medium"
        value={val}
        aria-label="Transaction limit"
        valueLabelDisplay="auto"
        max={max}
        min={min}
        step={step}
        onChange={handleChange}
        sx={{ color: '#f97316' }}
      />
      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-500">
          {formatCurrency(min, currencyCode)}
        </span>
        <span className="text-xs text-gray-500">
          {formatCurrency(max, currencyCode)}
        </span>
      </div>
      <div className="mt-4 h-8">
        <p className="break-words text-sm text-gray-600">{noteMessage}</p>
      </div>
      <Button
        type="button"
        onClick={() => onConfirm(val)}
        className="mt-8 w-full"
      >
        Confirm
      </Button>
    </div>
  );
};

export default SetLimitDialog;
